import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'materialClassId',
        fieldName: '类别',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'materialClass/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'brand',
        fieldName: '品牌',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'model',
        fieldName: '型号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'materialUnitId',
        fieldName: '物料单位',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'materialUnit/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      },
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'standard',
        fieldName: '封装规格',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      },
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'code',
        fieldName: '代码',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'parameter',
        fieldName: '参数',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'device',
        fieldName: '使用设备',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      },
      {
        componentType: 'el-upload',
        componentName: '下拉选择',
        fieldKey: 'images',
        fieldName: '图片',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          width: '100%',
          multiple: false,
          clearable: true
        }
      }, {
        componentType: 'el-textarea',
        componentName: '输入框',
        fieldKey: 'mark',
        fieldName: '描述',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          width: '100%'
        }
      }
    ]
  }
]
